export interface Module {
  title: string
  body: string
  /** Spine color of the matching book in the box-set mockup */
  color: string
}

export const modules: Module[] = [
  {
    title: 'APPLIANCE DIAGNOSTIC FUNDAMENTALS™',
    body: 'Build the foundation for structured fault-finding with electrical safety, multimeter testing, wiring diagrams, continuity, voltage, resistance, switches, relays, sensors, motors, pumps, valves, heating elements, control circuits, and systematic diagnostic workflows.',
    color: '#0798E8',
  },
  {
    title: 'REFRIGERATOR & FREEZER DIAGNOSTICS™',
    body: 'Troubleshoot cooling problems, compressor operation, fan faults, thermistors, thermostats, defrost systems, ice buildup, water leaks, temperature problems, electrical faults, and related refrigerator and freezer components.',
    color: '#D32F2F',
  },
  {
    title: 'WASHING MACHINE DIAGNOSTICS™',
    body: 'Follow structured diagnostic paths for no-start, no-fill, no-drain, no-spin, leaks, vibration, unusual noises, pumps, valves, motors, door locks, pressure systems, sensors, wiring, and control faults.',
    color: '#E89A0C',
  },
  {
    title: 'DRYER DIAGNOSTICS™',
    body: 'Diagnose no-heat conditions, overheating, no-tumble faults, long drying times, airflow restrictions, heating elements, thermal protection, thermostats, sensors, motors, belts, wiring, and electrical faults.',
    color: '#1E8E4E',
  },
  {
    title: 'DISHWASHER DIAGNOSTICS™',
    body: 'Troubleshoot no-fill, no-drain, poor cleaning, leaks, heating problems, pumps, valves, spray systems, float switches, door switches, sensors, wiring, and electronic controls.',
    color: '#7B3FC4',
  },
  {
    title: 'OVEN & RANGE DIAGNOSTICS™',
    body: 'Follow structured diagnostic references for no-heat, slow heating, incorrect temperatures, heating elements, igniters, burners, thermostats, temperature sensors, switches, wiring, and control-system faults.',
    color: '#4A5561',
  },
]
